import styled from "styled-components";

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioOption = styled.div<{ selected: boolean }>`
  border: 2px solid ${props => props.selected ? props.theme.colors.Primary : '#e5e7eb'};
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;

  &:hover {
    border-color: ${props => props.selected ? props.theme.colors.Primary : '#d1d5db'};
  }

  input[type="radio"] {
    margin: 0;
    cursor: pointer;
    width: 18px;
    height: 18px;
    accent-color: ${props => props.theme.colors.Primary};
  }

  > div {
    display: inline-block;
    width: calc(100% - 30px);
    vertical-align: top;
  }

  strong {
    display: block;
    font-size: 16px;
    color: #111827;
  }

  // p {
  //   margin: 0;
  //   font-size: 14px;
  //   color: #6b7280;
  //   line-height: 1.5;
  // }
`;

export const StepTitle = styled.div`
  
`;

export const StepLabel = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #111827;
`;

export const InfoBox = styled.div`
  background-color: ${props => `${props.theme.colors.Primary}08`};
  border: 1px solid ${props => `${props.theme.colors.Primary}30`};
  border-radius: 6px;
  padding: 12px;
  
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: ${props => props.theme.colors.Primary};
  line-height: 1.5;
`;

export const InfoIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.Primary};
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  flex-shrink: 0;
`;

export const StatusBadge = styled.div<{ isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  
  background-color: ${props => props.isOpen ? '#d1fae5' : '#fee2e2'};
  color: ${props => props.isOpen ? '#065f46' : '#991b1b'};
  border: 1px solid ${props => props.isOpen ? '#a7f3d0' : '#fecaca'};
`;

export const StatusDot = styled.div<{ isOpen: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.isOpen ? '#10b981' : '#ef4444'};
`;



export const SummaryWrapper = styled.div`
  margin-top: 24px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 8px;
`;

export const SummaryText = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 18px;
  color: #6b7280;
font-size: 13px;
  * {
    display: inline;
  }

  strong {
  font-size: 13px;
    display: inline;
    font-weight: 500;
    color: #111827;
    
  }
`;